import React from 'react';
import PropTypes from 'prop-types';
import Item from '../item/Item';
import queries from '../../graphql/queries';
import SearchIcon from 'material-ui/svg-icons/action/search';
import CircularProgress from 'material-ui/CircularProgress';
import { compose } from 'react-apollo';

class SearchResults extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    renderResults() {
        return (
            <ul className="materialList dense searchResultsList">
                {this.props.results.map(item => (
                    <li key={item.id} className="materialListItem threeLine searchResultsListItem">
                        <Item
                            projectId={this.props.project.id}
                            item={item}
                            queueItemViewButtons={[]}
                            listViewTemplate={this.props.project.itemListViewTemplate}
                        />
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        let results = null;
        if (this.props.loading && (this.props.results === null || this.props.results.length === 0)) {
            results = <CircularProgress className="activityIndicator"/>;
        } else if (this.props.results === null) {
            results = (
                <div className="searchResultsPlaceholder">
                    <SearchIcon style={{width: 50, height: 50}} color="rgba(0, 0, 0, 0.25)"/>
                </div>
            );
        } else if (this.props.results.length === 0) {
            results = <div className="noItemsFoundPlaceholder">No items were found</div>;
        } else {
            results = this.renderResults();
        }
        return (
            <div className="searchResults">
                {results}
            </div>
        );
    }

}

SearchResults.propTypes = {
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    results: PropTypes.array
};
SearchResults.defaultProps = {

};

export default compose(
    queries.searchQueryHoc
)(SearchResults);



// WEBPACK FOOTER //
// ./src/components/search/SearchResults.js